import { mergeStyleSets } from '@fluentui/react';

export const useStyles = () => mergeStyleSets({
  mappingsButton: {
    width: '100%',
  },
  options: {
    padding: '12px 0',
    display: 'flex',
    flexDirection: 'column',
    gap: '12px',
  },
  validationError: {
    width: '100%',
    textAlign: 'left',
    marginTop: '8px',
  },
  copyIdParams: {
    transition: 'max-height 500ms',
    maxHeight: '500px',
    overflow: 'hidden',
    '&.hidden': {
      maxHeight: '0',
    }
  },
  verifyRange: {
    display: 'flex',
    alignItems: 'center',
  },
  groupPane: {
    '& > div:first-child': {
      paddingLeft: '0',
      paddingRight: '0',
    }
  }
})